exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-expand label {\r\n  width: 100px;\r\n  color: #99a9bf;\n}\n.table-expand .el-form-item {\r\n  margin-right: 0;\r\n  margin-bottom: 0;\n}\n.reviewLog .el-dialog {\r\n  background: #f7f7f7;\r\n  border-radius: 15px;\r\n  overflow: hidden;\n}\n.reviewLog .el-dialog__footer {\r\n  padding: 0;\n}\n.reviewLog .el-dialog__body {\r\n  padding-top: 0\n}\r\n", ""]);

// exports
